import { render, staticRenderFns } from "./AyinNamehs.vue?vue&type=template&id=3966cda8"
import script from "./AyinNamehs.vue?vue&type=script&lang=js"
export * from "./AyinNamehs.vue?vue&type=script&lang=js"
import style0 from "./AyinNamehs.vue?vue&type=style&index=0&id=3966cda8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports